import { Skeleton } from "@/components/ui/skeleton";
import { PageHeader } from "@/components/common/FeatureShell";

export function ProjectsControlsSkeleton() {
  return (
    <div className="mb-4 flex flex-wrap gap-2">
      <Skeleton className="h-10 min-w-72 flex-1" />
      <Skeleton className="h-10 w-40" />
    </div>
  );
}

/**
 * Table skeleton for the projects list. Column widths (`1fr / 7rem / 6rem`)
 * and row height (`min-h-14`) mirror the real ProjectsPageClient table.
 */
export function ProjectsTableSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <div className="overflow-hidden rounded-md border bg-card">
      <div className="grid grid-cols-[minmax(0,1fr)_7rem_6rem] border-b px-3 py-2">
        <Skeleton className="h-3 w-12" />
        <Skeleton className="h-3 w-8" />
        <Skeleton className="h-3 w-10" />
      </div>
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="grid min-h-14 grid-cols-[minmax(0,1fr)_7rem_6rem] items-center border-b px-3 py-2 last:border-b-0">
          <span className="min-w-0">
            <Skeleton className="h-4 w-56 max-w-full" />
            <Skeleton className="mt-2 h-3 w-32 max-w-full" />
          </span>
          <Skeleton className="h-4 w-6" />
          <Skeleton className="h-4 w-6" />
        </div>
      ))}
    </div>
  );
}

export function ProjectsPageSkeleton() {
  return (
    <div className="min-h-screen">
      <PageHeader title="Matters" description="Matter workspaces with their own document sets and chats." />
      <main className="p-4 md:p-6">
        <ProjectsControlsSkeleton />
        <ProjectsTableSkeleton />
      </main>
    </div>
  );
}
